import { CompositeScreenProps } from '@react-navigation/native'
import React from 'react'

import { FollowersMembersTabs } from 'partials/FollowersMembersTabs'
import { Page } from 'partials/Page'

import { Separator } from 'widgets/Separator'

import { useUser } from 'hooks/useUser'

export const FollowersMembersPage = ({ route, navigation }: CompositeScreenProps<any, any>) => {
  const trainerId = route.params?.trainerId
  const { data: trainer } = useUser({ userId: trainerId })

  return (
    <Page
      withBack
      withNav
      title={`${trainer?.firstName} ${trainer?.lastName}'s Group`}
      navigation={navigation}
    >
      <Separator />
      {trainer && <FollowersMembersTabs trainer={trainer} />}
    </Page>
  )
}
